
export function rehabilitatorStats (patients) {
  return {
    patientsSelfWorkoutPercent: patientsSelfWorkoutPercent(patients)
  }
}

export function patientsSelfWorkoutPercent (patients) {
  return patients.reduce((acc, patient) => acc + patient.sessionDone, 0) * 100 / patients.length
}